export default "__VITE_ASSET__14302d1c__"